module.exports = __webpack_public_path__ + "static/media/img3.7982d8f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/img3.png
// module id = 569
// module chunks = 0